import {
  Button,
  Description,
  Dialog,
  Form,
  Header,
  RadioButton,
  RadioGroup,
  Text
} from '@opengov/component-library/dist';
import React from 'react';

import { IReportLocale } from '../../common/locale';

import styles from './ReportExportDialog.scss';

export interface IReportExportDialogProps {
  reportLocaleText: IReportLocale;
  isFiltersDisabled: boolean;
  formattedMaxExportRows: string;
  exportReport(filter: Filter): void;
  onClose(): void;
}

export type Filter = 'currentFilters' | 'noFilters';

export interface IReportExportDialogState {
  filter: Filter;
}

export class ReportExportDialog extends React.Component<IReportExportDialogProps, IReportExportDialogState> {
  constructor(props) {
    super(props);

    this.state = {
      filter: 'currentFilters'
    };
  }

  handleFilterChange = (filter: Filter) => {
    this.setState({ filter });
  };

  handleExport = (_e) => {
    this.props.exportReport(this.state.filter);
  };

  render() {
    const { isFiltersDisabled, onClose, formattedMaxExportRows, reportLocaleText } = this.props;

    return (
      <Dialog.Info onClose={onClose}>
        <div className={styles.container}>
          <Header variant="h2">{reportLocaleText.exportModal.title}</Header>
          <Description>{reportLocaleText.exportModal.description}</Description>
          <div className={styles.form}>
            <Form.Item label={reportLocaleText.exportModal.filter}>
              <div className={styles.radioGroup}>
                <RadioGroup
                  value={this.state.filter}
                  onChange={this.handleFilterChange}
                  dataTest="export-filters-radio-group"
                >
                  <RadioButton
                    label={reportLocaleText.exportModal.currentFilters}
                    value="currentFilters"
                    dataTest="export-option-current-filters"
                  />
                  <RadioButton
                    disabled={isFiltersDisabled}
                    label={reportLocaleText.exportModal.noFilters}
                    value="noFilters"
                    dataTest="export-option-no-filters"
                  />
                </RadioGroup>
              </div>
            </Form.Item>
          </div>
          {isFiltersDisabled && (
            <Text size="minimum" color="light" font="condensed">
              {reportLocaleText.exportModal.filterDisabledText({ max: formattedMaxExportRows })}
            </Text>
          )}
          <div className={styles.buttonGroup}>
            <Button onClick={onClose} dataTest="export-dialog-cancel-button">
              {reportLocaleText.exportModal.cancel}
            </Button>
            <Button variant="primary" onClick={this.handleExport} dataTest="export-dialog-send-button">
              {reportLocaleText.exportModal.send}
            </Button>
          </div>
        </div>
      </Dialog.Info>
    );
  }
}
